import strings from '../../Localization/Localization';

import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  users as usersRoutes,
  products as productsRoutes,
  services as servicesRoutes
} from '../Route/routes';

import { fetchPartnerUsers } from '../../API/Users';

let title = {
  fieldKey: "title",
  type: "text",
  label: strings.form.cart.title.label,
  validators: []
}

let description = {
  fieldKey: "description",
  type: "textarea",
  label: strings.form.cart.description.label,
  validators: []
}

let cartItems = {
  fieldKey: "cart_items",
  type: "table",
  label: strings.form.cart.cartItems.label,
  validators: [],

  table: {
    valuesToRows: (values) => {
      let result = [];
      values.forEach((value) => {
        if(value["service_master"] && value["service_master"]["id"]) {
          let master = {
            product_name: value["service_master"]["service_master"]["product_name"]+' - '+value["service_master"]["service_master"]["serial_number"],
            service: value["service_master"]["service_master"],
            type: "",
            quantity: "",
            price: null,
            discount: null,
            discount_unit: "",
            amendment: false
          };
          result.push(master);
        }
        let type = '';
        switch (value.product.price_type) {
          case 0:
            if(value.rented === true) {
              type = strings.form.product.priceType.options.option_1;
            }
            else {
              type = strings.form.product.priceType.options.option0;
            }
            break;
          case 1:
            type = strings.form.product.priceType.options.option1;
            switch (value["contract"]["bill_period"]) {
              case 1:
                type += ' ' + strings.form.contract.billPeriod.options.monthly;
                break;
              case 2:
                type += ' ' + strings.form.contract.billPeriod.options.fortnightly;
                break;
              case 3:
                type += ' ' + strings.form.contract.billPeriod.options.quarterly;
                break;
              case 6:
                type += ' ' + strings.form.contract.billPeriod.options.halfYearly;
                break;
              case 12:
                type += ' ' + strings.form.contract.billPeriod.options.yearly;
                break;
              default:
            }
            break;
          case 2:
            type = strings.form.product.priceType.options.option2;
            break;
          default:
        }
        result.push(Object.assign({}, value, {
          product_name: value.product.name,
          type: type,
          amendment: value["previous_amendment"] && value["previous_amendment"]["id"]?value["previous_amendment"]["service"]["id"]:false,
        }))
      });
      return result;
    },
    headers: [
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "string",
        value: (item) => {
          if(item.amendment) {
            return (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip>{strings.form.cart.cartItems.table.amendment.service}</Tooltip>
                }>
                <div className="item-index-status item-index-status-info-icon"><i className="icon-checkmark"/></div>
              </OverlayTrigger>
            )
          }
        },
        href: (item) => item && item.amendment && servicesRoutes.routes.show.createPath(item.amendment),
        label: (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>{strings.form.cart.cartItems.table.amendment.label}</Tooltip>
            }>
            <div className="item-index-status item-index-status-info-icon"><i className="icon-doc"/></div>
          </OverlayTrigger>
        ),
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "string",
        value: "product_name",
        href: (item) => {
          if(item && item["product"]) {
            return productsRoutes.routes.show.createPath(item["product"]["id"]);
          }
          else if(item && item["service"]) {
            return servicesRoutes.routes.show.createPath(item["service"]["id"]);
          }
        },
        label: strings.form.cart.cartItems.table.productName,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "string",
        value: "type",
        label: strings.form.cart.cartItems.table.type,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "integer",
        value: "quantity",
        label: strings.form.cart.cartItems.table.quantity,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "price",
        value: "price",
        label: strings.form.cart.cartItems.table.price,
        editable: false
      },
      {
        headerColSpan: 2,
        itemColSpan: 1,
        type: "float",
        value: "discount",
        label: strings.form.cart.cartItems.table.discount,
        editable: false
      },
      {
        headerColSpan: 0,
        itemColSpan: 1,
        type: "string",
        value: "discount_unit",
        label: strings.form.cart.cartItems.table.discountUnit,
        editable: false
      }
    ]
  }
}

let cartItemTechnicalData = {
  fieldKey: "cart_items",
  type: "array",
  label: "",

  validators: [],

  allowMoreField: false,
  defaultNumberOfField: 0,

  subField: {
    type: "subform",
    label: (key, values) => values[key]["product"]["name"],

    validators: [],

    subForm: {
      formKey: "cartItem",
      fields: [
        {
          fieldKey: "_technical_data_values",
          type: "array",
          label: "",

          validators: [],

          allowMoreField: false,
          defaultNumberOfField: 0,
          subField: {
            type: "array",
            label: "Entité #key#",

            validators: [],

            allowMoreField: false,
            defaultNumberOfField: 0,

            subField: {
              type: 'configurableField',
              label: "",
              validators: [],

              subField: () => {},
              subFieldConf: {
                label: (value) => value["technical_data"]["name"],
                type: (value) => 'text',
                disabled: () => false,
                validators: (value) => [],
                valueAttribute: 'value'
              },
            }
          }
        }
      ]
    }
  }
}

let state = {
  fieldKey: "state",
  label: strings.form.cart.state.label,
  type: "dropdown",
  validators: [],

  showEmpty: true,
  input: 'options',
  options: [
    {
      value: 'o_w_validation',
      label: strings.form.cart.state.options.order.waitingValidation
    },
    {
      value: 'o_c_period',
      label: strings.form.cart.state.options.order.cancellationPeriod
    },
    {
      value: 'o_w_a_payment',
      label: strings.form.cart.state.options.order.waitingAdvancePayment
    },
    {
      value: 'o_d_i_progress',
      label: strings.form.cart.state.options.order.deliveryInProgress
    },
    {
      value: 'o_d_scheduled',
      label: strings.form.cart.state.options.order.scheduled
    },
    {
      value: 'o_delivered',
      label: strings.form.cart.state.options.order.delivered
    },
    {
      value: 'o_canceled',
      label: strings.form.cart.state.options.order.canceled
    }
  ],
}

let clientReferrer = {
  fieldKey: "client_referrer",
  label: strings.form.cart.clientUser.label,
  type: "dropdownEntity",
  validators: [],

  disabledLink: (value, getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      if(value && (credentials.roles.includes('ROLE_USER_INDEX'))) {
        return usersRoutes.routes.show.createPath(value["id"]);
      }
    }
    return false;
  },

  showEmpty: true,
  loader: {
    id: "clientUser",
    loader: fetchPartnerUsers,
    loaderRequire: (value, getValues) => getValues(0) && getValues(0)["client"] && getValues(0)["client"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        partner_id: getValues(0)["client"]["id"]
      }]
    },
  },

  adapter: {
    requirement: (data) => data["id"] && data["displayname"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["displayname"],
  },
}

export const technicalDataForm = {
  formKey: "cart",
  fields: [
    cartItemTechnicalData
  ]
}

export const stateForm = {
  formKey: "cart",
  fields: [
    state
  ]
}

export const clientRefererForm = {
  formKey: "cart",
  fields: [
    clientReferrer
  ]
}

export const form = {
  formKey: "cart",
  fields: [
    title,
    description,
    cartItems
  ]
}
